import { useT } from "../../../shared/i18n/i18n";
import { CircleCheckBig, Loader2 } from "lucide-react";
import { useState } from "react";
import { usePublicForm } from "../../../features/form-intake/model/use-public-form";
import { IntakeForm } from "../../../features/form-intake/ui/intake-form";
import { Button } from "@/components/ui/button";

// Anonymous intake page behind a capability URL: no session, the token is
// the whole authorization.
export function PublicFormPage({ token }: { token: string }) {
  const t = useT();
  const form = usePublicForm(token);
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <main className="min-h-screen bg-background px-4 py-10">
      <div className="mx-auto flex w-full max-w-lg flex-col gap-4">
        {form.isPending ? (
          <div className="flex justify-center py-20">
            <Loader2 className="size-5 animate-spin text-muted-foreground" />
          </div>
        ) : form.isError || !form.data ? (
          <div className="rounded-lg border border-border/70 bg-card p-8 text-center">
            <h1 className="text-base font-semibold">{t("publicPage.formUnavailable")}</h1>
            <p className="mt-1.5 text-sm text-muted-foreground">{t("publicPage.linkDisabled")}</p>
          </div>
        ) : isSubmitted ? (
          <div className="flex flex-col items-center gap-3 rounded-lg border border-border/70 bg-card p-10 text-center">
            <CircleCheckBig className="size-8 text-emerald-500" />
            <div>
              <h1 className="text-base font-semibold">{t("publicPage.thanks")}</h1>
              <p className="mt-1 text-sm text-muted-foreground">The team will see it on “{form.data.boardName}”.</p>
            </div>
            <Button onClick={() => setIsSubmitted(false)} size="sm" variant="outline">
              {t("publicPage.submitAnother")}
            </Button>
          </div>
        ) : (
          <>
            <div>
              <h1 className="text-lg font-semibold">{form.data.formName}</h1>
              <p className="mt-0.5 text-sm text-muted-foreground">{form.data.boardName}</p>
            </div>
            <div className="rounded-lg border border-border/70 bg-card p-5">
              <IntakeForm
                fields={form.data.fields}
                onSubmit={async (input) => {
                  await form.submit(input);
                  setIsSubmitted(true);
                }}
              />
            </div>
          </>
        )}
      </div>
    </main>
  );
}
